import isNumber from 'lodash/isNumber';
import { memo, useMemo } from 'react';

import { thousands } from '~/helpers/formatting';

import { StatisticsValue } from '~/UIKit';

import styles from './ResourceCell.scss';

type ResourceCellProps = {
  memberId: number;

  value?: number | null;
  isHidden?: boolean;
  canViewLeveling?: boolean;
  isBonusActivated?: boolean | null;
  isHighlightedAdmittance?: boolean;
  disableTooltip?: boolean;
};

const ResourceCell = ({
  memberId,

  value = null,
  isHidden = false,
  canViewLeveling = false,
  isBonusActivated = null,
  isHighlightedAdmittance = false,
  disableTooltip = false,
}: ResourceCellProps) => {
  const isNeedTooltip = useMemo(() => {
    return !disableTooltip && isNumber(value) && Boolean(canViewLeveling) && !isBonusActivated;
  }, [canViewLeveling, disableTooltip, isBonusActivated, value]);

  const dataTip = isNeedTooltip ? memberId : null;
  const tooltipId = isNeedTooltip ? 'accumulative-clan-resource-tooltip' : null;

  const classNameResourceCell = isHighlightedAdmittance ? styles.isHighlightedAdmittance : undefined;

  return (
    <div data-tip={dataTip} data-for={tooltipId} className={classNameResourceCell}>
      <StatisticsValue value={thousands(value ?? 0)} isHidden={isHidden} disableTooltip={disableTooltip} />
    </div>
  );
};

ResourceCell.displayName = 'ResourceCell';

export default memo(ResourceCell);
